import { useQuery } from "@tanstack/react-query";

import { apiInstance } from "@/shared/api";

import { type TableApiCallParams } from "@/shared/types";
import { type PaginatedResponse } from "@/shared/types";
import { filterObjectKeys } from "@/shared/lib/utils";
import type { Teamlead } from "../model";

export const useTeamleads = (
  params: TableApiCallParams & { isMaster?: boolean; enabled?: boolean },
) => {
  return useQuery<PaginatedResponse<Teamlead>>({
    queryKey: ["teamleads", filterObjectKeys(params, ["enabled"])],
    queryFn: async () => {
      const { data } = await apiInstance.get<PaginatedResponse<Teamlead>>(
        "/teamleads",
        filterObjectKeys(params, ["enabled"]),
      );

      return data;
    },
    enabled: params.enabled,
  });
};
